import { SalesTransaction } from './transaction';
import { RepairWithId } from './repair';
import { ItemType } from './item';

export enum DateRangePreset {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_WEEK = 'this_week',
  LAST_WEEK = 'last_week',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  CUSTOM = 'custom',
}

export enum SoldItemsGrouping {
  NONE = 'none',
  BY_CATEGORY = 'by_category',
  BY_TYPE = 'by_type',
}

export interface CustomDateRange {
  startDate: Date | null;
  endDate: Date | null;
}

export interface ReportSoldItem {
  id: string;
  name: string;
  sellingPrice: number;
  sellingCurrency: string;
  saleDate: Date;
  categoryId?: string;
  categoryName?: string;
  itemType?: ItemType;
}

export interface SoldItemsGroup {
  groupKey: string;
  groupName: string;
  items: ReportSoldItem[];
  totalCount: number;
  totalRevenue: number;
  groupType: 'category' | 'type';
}

export interface ReportData {
  totalSalesInTry: number;
  totalCostOfGoodsSoldInTry: number;
  totalProfitInTry: number;
  totalRepairIncomeInTry: number;
  soldItems: ReportSoldItem[];
  soldItemsGrouped: {
    byCategory: SoldItemsGroup[];
    byType: SoldItemsGroup[];
  };
  dateRange: {
    start: Date;
    end: Date;
  };
}

export interface ReportContextState {
  reportData: ReportData | null;
  loading: boolean;
  error: string | null;
  selectedPreset: DateRangePreset;
  customDateRange: CustomDateRange;
  activeStartDate: Date;
  activeEndDate: Date;
  soldItemsGrouping: SoldItemsGrouping;
}